import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromDevice from './reducers/device.reducer';
import {EffectsModule} from '@ngrx/effects';
import {DeviceEffects} from './effects/device.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ DeviceEffects ]),
    StoreModule.forFeature('device', fromDevice.reducer),
  ]
})
export class DeviceModule { }
